export const getFromQueryString = name => {
  return new URLSearchParams(window.location.search).get(name)
}
